import { createBrowserRouter, Navigate } from 'react-router'
import { authRoutes } from '@/features/auth/routes'
import { ProtectedRoute } from '@/features/auth/ProtectedRoute'
import { PublicRoute } from '@/features/auth/PublicRoute'
import { dashboardRoutes } from '@/features/dashboard/routes'
import { ROUTES } from '@/shared/routes'
import { AppShell } from './AppShell'

export const router = createBrowserRouter([
  { element: <PublicRoute />, children: authRoutes },
  {
    element: <ProtectedRoute />,
    children: [{ element: <AppShell />, children: dashboardRoutes }],
  },
  { path: '*', element: <Navigate to={ROUTES.HOME} replace /> },
])
